import { LoadingContext } from 'context/LoadingContext'
import { useContextSelector } from 'use-context-selector'

const useLoading = () => {
  const loading = useContextSelector(LoadingContext, (state) => state.loading)

  const msgErro = useContextSelector(LoadingContext, (state) => state.msgErro)
  const setLoading = useContextSelector(
    LoadingContext,
    (state) => state.setLoading
  )

  const setMsgErro = useContextSelector(
    LoadingContext,
    (state) => state.setMsgErro
  )

  const setMsgSucesso = useContextSelector(
    LoadingContext,
    (state) => state.setMsgSucesso
  )
  const toggleSucessShow = useContextSelector(
    LoadingContext,
    (state) => state.toggleSucessShow
  )
  const loadingMessage = useContextSelector(LoadingContext, (state) => state.loadingMessage);
  const setLoadingMessage = useContextSelector(LoadingContext, (state) => state.setLoadingMessage)

  return {
    loading,
    msgErro,
    loadingMessage,
    setLoading,
    setMsgErro,
    setMsgSucesso,
    toggleSucessShow,
    setLoadingMessage
  }
}

export default useLoading
